<template>
    <or-modal
        ref="flow-entity-modal"
        class="flow-entity-modal"
        :title="$t('model.nlu-model.sidebar.flow_entities.flow_entity_modal.flowEntity')"
        dismissOn="close-button esc"
    >
        <div v-if="modelHasFlowEntity">
            <p>
              {{ $t('model.nlu-model.sidebar.flow_entities.flow_entity_modal.avaliableFlowEntitiesBelow') }}
              <span
                  class="fe-editor-link"
                  @click="openFlowEntityEditor"
              >
                {{ $t('model.nlu-model.sidebar.flow_entities.flow_entity_modal.clickHere') }}
              </span>
              {{ $t('model.nlu-model.sidebar.flow_entities.flow_entity_modal.toCreateNewOne') }}
            </p>
            <or-radio-group
                v-model="flowEntity"
                name="fllow-entites-group"
                vertical
                :options="flowEntitiesList"
            ></or-radio-group>
        </div>
        <div v-else>
            <p>
              {{ $t('model.nlu-model.sidebar.flow_entities.flow_entity_modal.modelHasNo') }}
              <span
                  class="fe-editor-link"
                  @click="openFlowEntityEditor"
              >
                {{ $t('model.nlu-model.sidebar.flow_entities.flow_entity_modal.clickHere') }}
              </span>
              {{ $t('model.nlu-model.sidebar.flow_entities.flow_entity_modal.toCreateOne') }}
            </p>
        </div>
        <div slot="footer">
            <div v-if="modelHasFlowEntity">
                <or-button
                    type="secondary"
                    :disabled="removeIsDisabled"
                    @click="removeFlowEntity"
                >
                  {{ $t('generic.remove') }}
                </or-button>
                <or-button
                    type="primary"
                    :disabled="appendIsDisabled"
                    @click="appendFlowEntity"
                >
                  {{ $t('generic.append') }}
                </or-button>
            </div>
            <div v-else>
                <or-button
                    type="secondary"
                    @click="$refs['flow-entity-modal'].close()"
                >
                  {{ $t('generic.close') }}
                </or-button>
            </div>
        </div>
    </or-modal>
</template>

<script>
import KnowledgeBus from '@/KnowledgeBus'
import { mapState } from 'vuex'

export default {
  created () {
    KnowledgeBus.$on('flow-entity-modal::open', this.openModal)
  },

  beforeDestroy () {
    KnowledgeBus.$off('flow-entity-modal::open', this.openModal)
  },

  props: {
    id: String,
    target: String // (intent|context)
  },

  computed: {
    ...mapState('knowledgebase/entities', ['postprocessEnities']),

    flowEntitiesList () {
      return _.map(this.postprocessEnities.value, item => ({
        label: item.name,
        value: item.id
      }))
    },

    modelHasFlowEntity () {
      return !_.isEmpty(this.postprocessEnities.value)
    },

    removeIsDisabled () {
      // return _.isEmpty(this.intent.postprocessFlows);

      return false
    },

    appendIsDisabled () {
      // return _.isEmpty(this.flowEntity)
      //     || _.includes(this.intent.postprocessFlows, this.flowEntity);

      return false
    }
  },

  data () {
    return {
      flowEntity: '',
      localTarget: String,
      localTargetId: String
    }
  },

  methods: {
    openFlowEntityEditor () {
      this.$refs['flow-entity-modal'].close()

      this.$nextTick(() => {
        KnowledgeBus.$emit('sidebar::open', 3)
      })
    },

    openModal ({ currentflowEntity, target, targetId }) {
      if (this.id === targetId) {
        this.$refs['flow-entity-modal'].open()

        this.flowEntity = currentflowEntity || ''
        this.localTarget = target
        this.localTargetId = targetId
      }
    },

    removeFlowEntity () {
      if (this.localTarget === 'intent') KnowledgeBus.$emit('intent-flow-entity::remove', this.localTargetId)
      if (this.localTarget === 'context') KnowledgeBus.$emit('context-flow-entity::remove', this.localTargetId)

      this.$refs['flow-entity-modal'].close()
    },

    appendFlowEntity () {
      const data = {
        targetId: this.localTargetId,
        flowEntity: this.flowEntity
      }

      if (this.localTarget === 'intent') KnowledgeBus.$emit('intent-flow-entity::append', data)
      if (this.localTarget === 'context') KnowledgeBus.$emit('context-flow-entity::append', data)

      this.$refs['flow-entity-modal'].close()
    }
  }
}
</script>

<style lang="scss" scoped>
    .flow-entity-modal {
        z-index: 1000;

        .fe-editor-link {
            color: $or-blue;

            &:hover {
                color: darken($or-blue, 10%);
                cursor: pointer;
            }
        }
    }
</style>
